const context = window.BrownfieldContext;

// eslint-disable-next-line
__webpack_public_path__ = addBase(context, 'staticUrl', '');

const videoPublicUrl = addBase(context, 'videoDir', 'videos/');
const serverURL = context ? (('serverURL' in context) ? checkSlash(context['serverURL']) : '/') : '/';

export { videoPublicUrl };
export { serverURL };

function addBase(context, matter, defaultRelPath = '') {
  return context
    ? (context.baseUrl ? checkSlash(context.baseUrl) : '') +
        (matter in context ? checkSlash(context[matter]) : defaultRelPath)
    : defaultRelPath;
}

function checkSlash(str) {
  if (str.length === 0 || str[str.length - 1] === '/') {
    return str;
  } else {
    return str.trim() + '/';
  }
}
